import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";


const Mst = () => {
  const headers = ['MST'];

  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>MST </h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              MST
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Method_Description', 'Protocol', 'Discussion', 'References']}
              currentClassName="active">

              <li><a href="#Method_Description">Method Description</a></li>
              <li><a href="#Protocol">Protocol</a></li>
              <li><a href="#Discussion">Discussion</a></li>
              <li><a href="#References">References</a></li>

            </Scrollspy>

            {/* <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header=>{
                   
                  return (
                    <li><a href={"#"+header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )
                  
                })
              }
            </Scrollspy> */}

            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-holding-flask-3-1.webp"
              alt="Mascot is holding a flask"

            />

          </div>

        </div>
        <div className="main_lab_style">
          <WindowBrowser header="MicroScale Thermophoresis (MST)" description={
            <>
              <div style={{ display: 'none' }}>
                {
                  headers.map(header => {
                    return (
                      <section href={header.split(' ')[0]}>{
                        header
                      }</section>
                    )

                  })
                }
              </div>

              <section id="Method_Description">
              <br></br>
              
                <h1>
                  Method Description
                </h1>
                <p>
                  MicroScale Thermophoresis (MST) is a powerful technique for determining the binding affinity between biological molecules including aptamers and antibodies only requires a small amount of sample [1]. This method leverages the movement of molecules in a temperature gradient to measure interactions with high precision and sensitivity (Fig. 1) [2]. Aptamers, which are short, single-stranded DNA or RNA molecules, can bind to specific targets with high affinity and specificity, making them excellent candidates for diagnostic and therapeutic applications. MST allows for the quantification of these interactions in real-time, providing valuable insights into the binding kinetics and thermodynamics. Recent studies, such as those published in the International Journal of Molecular Sciences [3] and Journal of Materials Chemistry [4], highlight the efficacy of MST in studying aptamer-antibody interactions diagnostics.
                </p>

                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/mst/1mst.png">
                </img>

                <p>
                  <strong>Figure 1. </strong>
                  Principle of the MST technology (picture was taken from free-access resource Wikipedia).
                </p>

              </section>

              <section id="Protocol">
              <br />
              <br />
                <h1>
                  Protocol
                </h1>

                <p>
                  Before the reaction, the 5’6-FAM-labeled aptamer conjugate (Integrated DNA Technologies, USA) was heated at 75℃ for 5 min and cooled down on the ice for 10 min. Bevacizumab (TargetMol, USA) was serially diluted to 16 samples from the highest concentration of 5 μM. MicroScale Thermophoresis (MST) measurements were carried out with a constant final concentration of 50 nM labeled aptamer in combination with a final concentration ranging from 5000 to 0.153 nM of bevacizumab, respectively. 10 μL aptamer and 10 μL bavacizumab of each titration step were mixed at 37°C for 30 min. The analyses were performed in Tris-HCl buffer: 25 mM Tris–HCl pH 6.3 (Alfa Aesar Chemicals, China), 150 mM KCl (International Laboratory USA, USA), 1 mM MgCl<sub>2</sub> (Sinopharm Chemical Reagent, China), 0.05% Tween 20 (Thermo Fisher Scientific, Belgium). All MST measurements were carried out on a Monolith NT.115 (NanoTemper Technologies GmbH, Germany) by standard capillaries. The curve fitting and K<sub>d</sub> determination were obtained from Affinity Analysis for Monolith NT.115 Series Instruments Software v2.3.
                </p>
                <p>
                  Statistical analysis was performed with an unpaired two-tailed t-test using GraphPad Prism Software (GraphPad Software Inc., CA) with p &lt; 0.05 considered significant.
                </p>
              </section>

              <section id="Discussion">
              <br />
              <br />
                <h1>
                  Discussion
                </h1>

                <p>
                  To evaluate the binding affinity, we performed the binding of bevacizumab to the initial aptamer <strong>А14#1</strong> (5′-GCGGTTGGTGGTAGTTACGTTCGC-3′) via MST (Fig. 2). The dissociation constant K<sub>d</sub> was determined to be 11.0 ± 3.7 nM under pH 6.3, mean standard deviations were calculated based on at least three independent experiments. The results are similar to the results of Saito et al with K<sub>d</sub> 12 nM for pH 7.4 obtained from the ELONA assay [5]. For our MST experiments, we selected a pH to closely mimic the clinical conditions of bevacizumab solutions – pH 6.2 [6].
                </p>

                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/mst/2-mst.png">
                </img>
                <p>
                  <strong>Figure 2. (A)</strong> Relative Fluorescence vs time was determined for 16 capillaries with investigating solutions. <strong>(B)</strong> Fraction Bound vs bevacizumab concentration of 50 nM of FAM-labeled aptamer <strong>А14#1</strong> and 5000 to 0.153 nM of bevacizumab.
                </p>

                <p>
                  The dissociation constant K<sub>d</sub> for aptamer <strong>CU2#19</strong> (5′-GCGGTTGGTGGTAGTTACGGTCGC-3′) was determined to be 10.4 ± 1.5 nM under pH 6.3, mean standard deviations were calculated based on at least three independent experiments (Fig. 3). Although the K<sub>d</sub> of aptamer <strong>CU2#19</strong> is better than that of the <strong>А14#1</strong>, the difference is not statistically significant. Therefore, we decided to use ELONA as another method to evaluate the binding of the aptamers to bevacizumab [7,8].
                </p>
                <img src="https://static.igem.wiki/teams/5334/wiki-images/lab/mst/3-mst.png">
                </img>
                <p>
                  <strong>Figure 3. (A)</strong>
                  Relative Fluorescence vs time was determined for 16 capillaries with investigating solutions. <strong>(B)</strong> Fraction Bound vs bevacizumab concentration of 50 nM of FAM-labeled aptamer <strong>CU2#19</strong> and 1250 to 0.153 nM of bevacizumab.
                </p>

                <p>
                  In our MST assays, this unspecific binding was a significant factor contributing to fluctuations in binding measurements for the aptamers. Such variability resulted in false positives and reduced assay sensitivity, complicating the interpretation of experimental results [9]. To mitigate these effects and evaluate K<sub>d</sub> correctly, we optimized the assay, made independent experiments, and excluded results that were outliers. This approach is consistent with the paper of Chen et al., who demonstrated similar optimization by presenting only 8 data points on a graph using a machine with 16 capillaries [10].
                </p>
              </section>

              <section id="References">
                <br />
                <br />
                <p>
                  <h1> References </h1>
                </p>
                <ol>
                  <li>
                    Lam, S. Y., Lau, H. L. & Kwok, C. K. Capture-SELEX: Selection Strategy, Aptamer Identification, and Biosensing Application. Biosensors (Basel) 12, 1142 (2022).
                  </li>
                  <li>
                    Jerabek-Willemsen, M. et al. MicroScale Thermophoresis: Interaction analysis and beyond. J Mol Struct 1077, 101–113 (2014).
                  </li>
                  <li>
                    Domsicova, M., Korcekova, J., Poturnayova, A. & Breier, A. New Insights into Aptamers: An Alternative to Antibodies in the Detection of Molecular Biomarkers. Int J Mol Sci 25, 6833 (2024).
                  </li>
                  <li>
                    Yang, C. et al. Aptamers: an emerging navigation tool of therapeutic agents for targeted cancer therapy. J Mater Chem B 10, 20–33 (2022).
                  </li>

                  <li>
                    Saito, T. et al. Development of a DNA aptamer that binds to the complementarity-determining region of therapeutic monoclonal antibody and affinity improvement induced by pH-change for sensitive detection. Biosens Bioelectron 203, 114027 (2022).
                  </li>
                  <li>
                    Ingram, R. L. & Weiser, S. E. Development of the Drug Product Formulation of the Bevacizumab Biosimilar PF-06439535 (Bevacizumab-bvzr). Drugs R D 23, 55–64 (2023).
                  </li>
                  <li>
                    Toh, S. Y., Citartan, M., Gopinath, S. C. B. & Tang, T.-H. Aptamers as a replacement for antibodies in enzyme-linked immunosorbent assay. Biosens Bioelectron 64, 392–403 (2015).
                  </li>
                  <li>
                    Song, S., Wang, L., Li, J., Fan, C. & Zhao, J. Aptamer-based biosensors. TrAC Trends in Analytical Chemistry 27, 108–117 (2008).
                  </li>
                  <li>
                    Yoo, H., Jo, H. & Oh, S. S. Detection and beyond: challenges and advances in aptamer-based biosensors. Mater Adv 1, 2663–2687 (2020).
                  </li>
                  <li>
                    Chen, K. et al. Aptamers as Versatile Molecular Tools for Antibody Production Monitoring and Quality Control. J Am Chem Soc 142, 12079–12086 (2020).
                  </li>

                </ol>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </section>
            </>
          } />
        </div>
      </section>
    </div>
  );
}

export default Mst;
